// RefundInfoDialog.js
import React, { useState, useEffect } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, Button, 
    TextField, Box, Typography 
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { formatCurrency } from '../../utils/currencyUtils'; // Đảm bảo đường dẫn import đúng
import { formatDateDisplay } from '../../utils/dateUtils'; // Đảm bảo đường dẫn import đúng

const RefundInfoDialog = ({ open, onClose, selectedBookings, showToast }) => {
    const [content, setContent] = useState('');

    useEffect(() => {
        if (open && selectedBookings && selectedBookings.length > 0) { // Thêm check tồn tại
            let text = `DANH SÁCH KHÁCH HÀNG CẦN HOÀN TIỀN\n`;
            text += `Ngày lập: ${new Date().toLocaleDateString('vi-VN')}\n`;
            text += `--------------------------------------------------\n`;
            
            let totalRefund = 0;

            selectedBookings.forEach((bk, index) => {
                let amount = parseFloat(bk.refund_amount) || 0;
                if (amount === 0 && bk.payables) {
                     const p = bk.payables.find(x => x.payable_type === 'REFUND');
                     if (p) amount = parseFloat(p.amount);
                }
                
                let accountInfo = bk.refund_account_info;
                if (!accountInfo && bk.payables) {
                     const p = bk.payables.find(x => x.payable_type === 'REFUND');
                     if (p) accountInfo = p.receiver_info;
                }

                totalRefund += amount;
                
                const custName = bk.customer_detail?.name || bk.customer_name || 'Khách lẻ';
                
                text += `${index + 1}. Khách hàng: ${custName} (Mã: ${bk.booking_code})\n`;
                text += `   - Số tiền hoàn: ${formatCurrency(amount)} VND\n`;
                text += `   - Thông tin TK: ${accountInfo || 'Chưa cập nhật'}\n`;
                text += `--------------------------------------------------\n`;
            });

            text += `TỔNG CỘNG CẦN HOÀN: ${formatCurrency(totalRefund)} VND\n`;
            setContent(text);
        }
    }, [open, selectedBookings]);

    const handleCopy = () => {
        navigator.clipboard.writeText(content);
        if (showToast) showToast('Đã copy nội dung hoàn tiền!', 'success');
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ bgcolor: '#d32f2f', color: 'white' }}>
                THÔNG TIN HOÀN TIỀN ({selectedBookings.length} Booking)
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', gap: 2, height: '450px' }}>
                    {/* Cột trái: Danh sách booking */}
                    <Box sx={{ width: '35%', borderRight: '1px solid #eee', pr: 2, overflowY: 'auto' }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                            Danh sách đơn hoàn:
                        </Typography>
                        {selectedBookings.map((bk, i) => (
                            <Box key={bk.booking_code} sx={{ p: 1, mb: 1, bgcolor: '#ffebee', borderRadius: 1, border: '1px solid #ffcdd2' }}>
                                <Typography variant="body2" fontWeight="bold" sx={{ color: '#d32f2f', mb: 0.5 }}>
                                    #{i + 1} - {bk.customer_detail?.name || 'Khách'}
                                </Typography>
                                <Typography variant="caption" display="block">
                                    Mã: {bk.booking_code}
                                </Typography>
                                <Typography variant="caption" display="block" sx={{fontWeight:'bold'}}>
                                    Hoàn: {formatCurrency(bk.refund_amount)}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                    
                    {/* Cột phải: Nội dung text */}
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                            Nội dung chi tiết (Copy gửi kế toán):
                        </Typography>
                        <TextField
                            multiline
                            fullWidth
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            sx={{ 
                                flex: 1, 
                                bgcolor: '#fafafa',
                                '& .MuiInputBase-root': {
                                    height: '100%',
                                    alignItems: 'flex-start',
                                    fontFamily: 'monospace', // Font monospaced để căn lề đẹp
                                    fontSize: '0.9rem'
                                }
                            }}
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">Đóng</Button>
                <Button 
                    variant="contained" 
                    color="error" // Dùng màu đỏ cho hành động liên quan đến tiền/hủy
                    startIcon={<ContentCopyIcon />}
                    onClick={handleCopy} 
                >
                    Copy nội dung
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RefundInfoDialog;